import React from "react";
import { compose } from "redux";
import { useSelector } from "react-redux";
import { getIsSso } from "../../store/personal-user";
import withPersonalization from "../with-personalization";
import withSecretQuestions from "../with-secret-questions";
import CoppaStrategy from "../coppa-strategy";
import AccessDeniedError from "../access-denied-error";
import SecretQuestionUpdatePage from "./secret-question-update-page";

const SecretQuestionUpdate = () => {
  const isSso = useSelector(getIsSso);

  const CoppaComponent = isSso ? AccessDeniedError : SecretQuestionUpdatePage;

  return (
    <CoppaStrategy
      coppaComponent={CoppaComponent}
      nonCoppaComponent={AccessDeniedError}
    />
  );
};

export { SecretQuestionUpdate };
export default compose(
  withPersonalization,
  withSecretQuestions
)(SecretQuestionUpdate);
